module.exports = __webpack_public_path__ + "static/media/EH.79afdf21.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/ministries/EH.svg
// module id = 255
// module chunks = 0